// Advertising disclosure and opt-in controls for pages that carry AdSense code.
(function() {
    'use strict';
    var advertisingPlaceholder = document.querySelector('[data-ad-client-script]');
    var legacyAdvertising = document.querySelector('script[src*="pagead2.googlesyndication.com"]');
    if (!advertisingPlaceholder && !legacyAdvertising) return;
    function readStoredChoice() {
        try {
            return localStorage.getItem('cookie_consent') || '';
        } catch (_) {
            return '';
        }
    }
    function updateConsent(granted) {
        if (typeof window.gtag === 'function') window.gtag('consent', 'update', {
            ad_storage: granted ? 'granted' : 'denied',
            ad_user_data: granted ? 'granted' : 'denied',
            ad_personalization: granted ? 'granted' : 'denied',
            analytics_storage: 'denied'
        });
    }
    function loadAdvertising() {
        if (!advertisingPlaceholder || document.querySelector('script[data-ad-client-loaded]')) return;
        var source = advertisingPlaceholder.getAttribute('data-ad-client-script');
        if (!source) return;
        var script = document.createElement('script');
        script.async = true;
        script.crossOrigin = 'anonymous';
        script.src = source;
        script.setAttribute('data-ad-client-loaded', 'true');
        advertisingPlaceholder.insertAdjacentElement('afterend', script);
    }
    var stored = readStoredChoice();
    if (stored === 'accepted') {
        updateConsent(true);
        loadAdvertising();
        return;
    }
    if (stored === 'essential') {
        updateConsent(false);
        return;
    }
    var basePath = window.location.pathname.includes('/guides/') ? '..' : '.';
    var banner = document.createElement('div');
    banner.id = 'cookie-consent-banner';
    banner.setAttribute('role', 'dialog');
    banner.setAttribute('aria-label', "\u5E7F\u544A Cookie \u8BBE\u7F6E");
    banner.setAttribute('aria-live', 'polite');
    banner.innerHTML = '<div class="cc-inner"><div class="cc-text"><strong>\u5E7F\u544A\u4E0E Cookie \u8BBE\u7F6E</strong>\uFF1A\u672C\u5185\u5BB9\u9875\u53EF\u52A0\u8F7D Google \u5E7F\u544A\u3002\u201C\u4EC5\u5FC5\u8981\u201D\u4E0D\u4F1A\u52A0\u8F7D\u5E7F\u544A\u670D\u52A1\uFF1B\u540C\u610F\u540E\u624D\u4F1A\u542F\u7528\u5E7F\u544A\u5B58\u50A8\u3001\u5E7F\u544A\u7528\u6237\u6570\u636E\u548C\u4E2A\u6027\u5316\u3002\u8BE6\u60C5\u89C1 <a href="' + basePath + '/privacy">\u9690\u79C1\u653F\u7B56</a>\u3001<a href="' + basePath + '/ad-disclosure">\u5E7F\u544A\u58F0\u660E</a>\u3002' + '</div>' + '<div class="cc-actions">' + '<button class="cc-btn cc-btn-essential" id="cc-essential-btn">\u4EC5\u5FC5\u8981</button>' + '<button class="cc-btn cc-btn-accept" id="cc-accept-btn">\u540C\u610F\u5E7F\u544A Cookie</button>' + '</div>' + '</div>';
    document.body.appendChild(banner);
    window.setTimeout(function() {
        banner.classList.add('cc-visible');
    }, 350);
    function saveChoice(choice) {
        try {
            localStorage.setItem('cookie_consent', choice);
        } catch (_) {
        // The current-page choice still applies when storage is unavailable.
        }
        var accepted = choice === 'accepted';
        updateConsent(accepted);
        if (accepted) loadAdvertising();
        banner.classList.remove('cc-visible');
        window.setTimeout(function() {
            banner.remove();
        }, 300);
    }
    document.getElementById('cc-essential-btn').addEventListener('click', function() {
        saveChoice('essential');
    });
    document.getElementById('cc-accept-btn').addEventListener('click', function() {
        saveChoice('accepted');
    });
})();

//# sourceMappingURL=path0.db131569.js.map
